import React, { useRef, useEffect, useContext } from "react";
// import PubSub from "pubsub-js";
import Image from "./Image";
import Texte from "./Texte";
import Slider from "./Slider";
import { _localizeField } from "../../core/utils";
import { WrapperContext } from "../Layout";
import clsx from "clsx";
// import { throttle } from "throttle-debounce";

const TexteImages = ({ input, index, len }) => {
  const { isMobile } = useContext(WrapperContext);

  const imagesRef = useRef();
  // const texteRef = useRef();
  const stickyRef = useRef();
  const ghostRef = useRef();
  const texteRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 1);
    _format();

    window.addEventListener("resize", _format);

    return () => {
      window.removeEventListener("resize", _format);
    };
  }, []);

  const _format = () => {
    if (isMobile || window.innerWidth < 982) return;

    setTimeout(() => {
      _formatImages();
    }, 400);
  };

  const _formatImages = () => {
    const wrapperTop = document
      .querySelector(".modules")
      .getBoundingClientRect().top;

    const ghostImgHeight = ghostRef.current.getBoundingClientRect().height;
    const { top, height } = texteRef.current.getBoundingClientRect();
    const topMinusScroll = top - wrapperTop;
    const imagesHeight = topMinusScroll + ghostImgHeight;
    // console.log(wrapperTop, imagesHeight, ghostImgHeight);
    imagesRef.current.style.height = `${imagesHeight}px`;

    imagesRef.current.style.opacity = 1;
    texteRef.current.style.opacity = 1;
  };
  // console.log(input);

  return (
    <>
      <section
        // style={{ backgroundColor: `#1234${index}1` }}
        className={clsx(
          "texte-images--images sm:mbS",
          `index-${index}`,
          index === len - 1 ? "is-last" : ""
        )}
        data-index={index}
        ref={imagesRef}>
        {input.images && input.images.length > 0 && (
          <div className='images'>
            <div className='sticky-wrapper' ref={stickyRef}>
              {input.images.length > 1 ? (
                <Slider input={input.images} />
              ) : (
                <Image input={input.images[0].image} />
              )}
            </div>
          </div>
        )}
      </section>

      <section
        className={clsx("texte-images--texte sm:mbM", `index-${index}`)}
        data-title={_localizeField(input.title)}
        id={input._key}
        ref={texteRef}>
        <div className='ghost-img mbM-' ref={ghostRef}></div>
        <div className='texte'>
          <Texte input={input.texte} />
          <div className='cartouche'></div>
        </div>
      </section>
    </>
  );
};

export default TexteImages;
